import { render, staticRenderFns } from "./calyrafit-side-by-side.vue?vue&type=template&id=4f35afdf&scoped=true&"
import script from "./calyrafit-side-by-side.vue?vue&type=script&lang=js&"
export * from "./calyrafit-side-by-side.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-side-by-side.vue?vue&type=style&index=0&id=4f35afdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f35afdf",
  null
  
)

export default component.exports